import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const ChatIcon = (props: any) => (
  <Svg width={20} height={18} fill="none" {...props}>
    <Path
      stroke={props.active?"rgba(192, 164, 111, 1)":"white"}
      strokeLinejoin="round"
      d="M1 3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14l-4.5-3H3a2 2 0 0 1-2-2V3Z"
    />
  </Svg>
);
export default ChatIcon;
